import { jsxs as t, jsx as a } from "react/jsx-runtime";
import * as i from "react";
import { cva as p } from "class-variance-authority";
import { cn as h } from "../../../lib/utils.js";
const u = p(
  "inline-flex items-center justify-center gap-2 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all duration-300 ease-luxury focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lpr-teal/50 focus-visible:ring-offset-2 focus-visible:shadow-glow ring-offset-bg-surface disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]",
  // Tactile press effect
  {
    variants: {
      variant: {
        primary: "bg-lpr-teal text-white shadow-luxury hover:bg-lpr-teal/90 hover:-translate-y-0.5 hover:shadow-premium dark:bg-lpr-teal dark:text-lpr-neutral dark:hover:bg-lpr-teal/80",
        secondary: "bg-lpr-gold text-white shadow-luxury hover:bg-lpr-gold/90 hover:-translate-y-0.5 hover:shadow-premium dark:bg-lpr-gold dark:text-lpr-charcoal dark:hover:bg-lpr-gold/80",
        outline: "border-2 border-lpr-teal/20 text-lpr-teal bg-transparent hover:border-lpr-teal hover:bg-lpr-teal/5 hover:-translate-y-0.5 dark:border-lpr-aqua/20 dark:text-lpr-aqua dark:hover:bg-lpr-aqua/5",
        ghost: "text-lpr-charcoal bg-transparent shadow-none hover:bg-lpr-teal/5 hover:text-lpr-teal dark:text-lpr-neutral dark:hover:bg-lpr-gold/5 dark:hover:text-lpr-gold",
        link: "text-lpr-teal underline underline-offset-4 shadow-none hover:text-lpr-gold hover:no-underline dark:text-lpr-aqua dark:hover:text-lpr-gold",
        default: "bg-bg-surface text-text-primary border border-border-color shadow-card hover:bg-lpr-aqua/20 hover:border-lpr-teal/40 hover:-translate-y-0.5 hover:shadow-luxury",
        destructive: "bg-lpr-red text-white shadow-card hover:bg-lpr-red/80 hover:-translate-y-0.5 hover:shadow-luxury"
      },
      size: {
        sm: "h-9 px-4",
        md: "h-11 px-6",
        lg: "h-14 px-8",
        icon: "h-10 w-10 p-0 rounded-full"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "md"
    }
  }
), c = i.forwardRef(({ className: l, variant: o, size: s, isLoading: r, children: d, ...e }, n) => t("button", { ref: n, disabled: r || e.disabled, className: h(u({ variant: o, size: s }), r && "opacity-70 cursor-wait", l), ...e, children: [r && t("svg", { className: "mr-2 h-4 w-4 animate-spin text-current", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [a("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), a("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" })] }), d] }));
c.displayName = "Button";
export {
  c as Button,
  u as buttonVariants
};
//# sourceMappingURL=Button.js.map
